import React, { useState } from 'react';
import { ShowIf } from '@apply/components';
import { CheckoutButtonPanel } from './components/CheckoutButtonPanel/CheckoutButtonPanel';
import { CustomPaymentStep } from '../../constants/CustomPaymentStep';
import { CardPayment } from './components/CardPayment/CardPayment';
import { PaymentAgreementCheckButton } from './components/PaymentAgreementCheckBox';
import { UnsupportedPaymentMessage } from './components/UnsupportedPaymentMessage';
import { CustomPaymentErrorMessage } from './components/CustomPaymentErrorMessage';
import { useCustomPaymentCardType } from '../../fields/CustomPaymentFields';

interface CheckoutFormProps {
    customPaymentGuid: string;
    set_paymentStep: React.Dispatch<React.SetStateAction<CustomPaymentStep>>;
}

export const CheckoutForm: React.FC<CheckoutFormProps> = ({ customPaymentGuid, set_paymentStep }) => {
    const [errorMessage, set_errorMessage] = useState<string | undefined>(undefined);

    const [cardType] = useCustomPaymentCardType(customPaymentGuid);
    const notSupportedCardType = cardType != 'VISA' && cardType != 'MASTERCARD' && cardType != undefined;

    const [paymentAgreementAccepted, set_paymentAgreementAccepted] = useState<boolean>(false);
    return (
        <>
            <div className='customPayment-checkoutForm'>
                <CardPayment
                    customPaymentId={customPaymentGuid}
                    disabled={false}
                />
                <PaymentAgreementCheckButton
                    paymentAgreementAccepted={paymentAgreementAccepted}
                    set_paymentAgreementAccepted={set_paymentAgreementAccepted}
                />
                <ShowIf showIf={notSupportedCardType && cardType}>
                    <UnsupportedPaymentMessage />
                </ShowIf>
                <ShowIf showIf={errorMessage}>
                    <CustomPaymentErrorMessage errorMessage={errorMessage} />
                </ShowIf>
                <CheckoutButtonPanel
                    customPaymentId={customPaymentGuid}
                    paymentAgreementAccepted={paymentAgreementAccepted}
                    notSupportedCardType={notSupportedCardType}
                    set_paymentStep={set_paymentStep}
                    errorMessage={errorMessage}
                    set_errorMessage={set_errorMessage}
                />
            </div>
        </>
    );
};
